module.exports = __webpack_public_path__ + "img/cpsb_summary_Image.8a2e7426.png";